{
  // Handle setting initial slide when modal opens from location gallery image click
  document.addEventListener('click', (e) => {
    const toggler = e.target.closest('button[is="ada-modal-toggler"][data-slide-index]')
    if (!toggler) return

    const modalId = toggler.getAttribute('aria-controls')
    if (!modalId.includes('location-gallery-')) return

    const slideIndex = parseInt(toggler.getAttribute('data-slide-index'))
    const modal = document.querySelector(`ada-modal#${modalId}`)
    
    if (modal) {
      // Listen for the modal open event
      const handleOpen = () => {
        const slider = modal.querySelector('ada-slider')
        if (slider && slider.$slick) {
          // Force slick to recalculate dimensions after modal is visible
          jQuery(slider).slick('setPosition')
          // Then go to the correct slide
          jQuery(slider).slick('slickGoTo', slideIndex)
        }
        modal.removeEventListener('open', handleOpen)
      }
      
      modal.addEventListener('open', handleOpen)
    }
  })
}
